<template>
  <v-card class="pa-4">
    <v-card-title>{{ $t('title') }}</v-card-title>
    <v-card-text>
      <v-switch v-model="account_lifecycle" :label="$t('account_lifecycle.label')"></v-switch>
      <v-switch v-model="usage_help" :label="$t('usage_help.label')"></v-switch>
      <v-switch v-model="promotions" :label="$t('promotions.label')"></v-switch>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Notifications',
  data () {
    return {
      account_lifecycle: null,
      usage_help: null,
      promotions: null,
    }
  },
  watch: {
    async account_lifecycle (newVal, oldVal) {
      if(oldVal !== null) {
        await this.$account.setMeta('notify_account_lifecycle', newVal)
        await this.$ui.success(this.$t('saved'))
      }
    },
    async usage_help (newVal, oldVal) {
      if(oldVal !== null) {
        await this.$account.setMeta('notify_usage_help', newVal)
        this.$ui.success(this.$t('saved'))
      }
    },
    async promotions (newVal, oldVal) {
      if(oldVal !== null) {
        await this.$account.setMeta('notify_promotions', newVal)
        this.$ui.success(this.$t('saved'))
      }
    },
  },
  mounted () {
    this.account_lifecycle = this.$account.getMeta('notify_account_lifecycle', true)
    this.usage_help = this.$account.getMeta('notify_usage_help', true)
    this.promotions = this.$account.getMeta('notify_promotions', true)
  }
}

</script>

<i18n>
{
	"en": {
		"account_lifecycle": {
			"label": "Emails concerning the life cycle of your account (subscription, suspension, update)."
		},
		"promotions": {
			"label": "Promotional emails (special offers, new services)."
		},
		"saved": "Notification preferences updated.",
		"title": "Notifications",
		"usage_help": {
			"label": "Help emails including usage tips, tutorials, application updates."
		}
	},
	"es": {
		"account_lifecycle": {
			"label": "Correos electrónicos relacionados con el ciclo de vida de su cuenta (suscripción, suspensión, actualización)."
		},
		"promotions": {
			"label": "Correos electrónicos promocionales (ofertas especiales, nuevos servicios)."
		},
		"saved": "Se actualizaron las preferencias de notificación.",
		"title": "Notificaciones",
		"usage_help": {
			"label": "Correos electrónicos de ayuda que incluyen consejos de uso, tutoriales y actualizaciones de aplicaciones."
		}
	},
	"fr": {
		"account_lifecycle": {
			"label": "E-mails concernant le cycle de vie de votre compte (abonnement, suspension, mise à jour)."
		},
		"promotions": {
			"label": "E-mails promotionnels (offres spéciales, nouveaux services)."
		},
		"saved": "Préférences de notification mises à jour.",
		"title": "Notifications",
		"usage_help": {
			"label": "E-mails d'aide comprenant des conseils d'utilisation, des didacticiels, des mises à jour de l'application."
		}
	},
	"it": {
		"account_lifecycle": {
			"label": "Email relative al ciclo di vita del tuo account (abbonamento, sospensione, aggiornamento)."
		},
		"promotions": {
			"label": "Email promozionali (offerte speciali, nuovi servizi)."
		},
		"saved": "Preferenze di notifica aggiornate.",
		"title": "Notifiche",
		"usage_help": {
			"label": "Email di aiuto con suggerimenti d'uso, tutorial e aggiornamenti dell'applicazione."
		}
	},
	"pt": {
		"account_lifecycle": {
			"label": "E-mails relativos ao ciclo de vida da sua conta (subscrição, suspensão, atualização)."
		},
		"promotions": {
			"label": "E-mails promocionais (ofertas especiais, novos serviços)."
		},
		"saved": "Preferências de notificação atualizadas.",
		"title": "Notificações",
		"usage_help": {
			"label": "E-mails de ajuda com dicas de utilização, tutoriais e atualizações da aplicação."
		}
	},
	"pl": {
		"account_lifecycle": {
			"label": "E-maile dotyczące cyklu życia Twojego konta (subskrypcja, zawieszenie, aktualizacja)."
		},
		"promotions": {
			"label": "E-maile promocyjne (oferty specjalne, nowe usługi)."
		},
		"saved": "Preferencje powiadomień zostały zaktualizowane.",
		"title": "Powiadomienia",
		"usage_help": {
			"label": "E-maile pomocnicze zawierające wskazówki dotyczące użytkowania, samouczki i aktualizacje aplikacji."
		}
	}
}
</i18n>
